export default {
  forgotLink: 'Mot de passe oublié ?',
  backToLogin: 'Retour à la connexion',
  passwordPolicy: 'Au moins {{min}} caractères.',
  mismatch: 'Les deux mots de passe ne correspondent pas.',
  forgot: {
    title: 'Mot de passe oublié',
    subtitle: 'Entrez le courriel de votre compte. Nous vous enverrons un lien pour choisir un nouveau mot de passe.',
    email: 'Courriel',
    submit: 'Envoyer le lien',
    sentTitle: 'Vérifiez vos courriels',
    sent: 'Si un compte existe pour {{email}}, un lien de réinitialisation vient d’être envoyé. Il est valide pendant une heure. Pensez à vérifier vos courriels indésirables.',
  },
  reset: {
    title: 'Nouveau mot de passe',
    subtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
    password: 'Nouveau mot de passe',
    confirm: 'Confirmer le mot de passe',
    submit: 'Enregistrer le mot de passe',
    successTitle: 'Mot de passe modifié',
    success: 'Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.',
    goToLogin: 'Se connecter',
    invalidTitle: 'Lien invalide ou expiré',
    invalid: 'Ce lien de réinitialisation n’est plus valide (il a expiré ou a déjà été utilisé). Demandez-en un nouveau.',
    requestNew: 'Demander un nouveau lien',
  },
  change: {
    title: 'Mot de passe',
    subtitle: 'Pour votre sécurité, votre mot de passe actuel est demandé.',
    open: 'Changer mon mot de passe',
    current: 'Mot de passe actuel',
    next: 'Nouveau mot de passe',
    confirm: 'Confirmer le nouveau mot de passe',
    submit: 'Mettre à jour',
    cancel: 'Annuler',
    success: 'Votre mot de passe a été modifié.',
    forgot: 'Mot de passe actuel oublié ?',
  },
  errors: {
    INVALID_RESET_TOKEN: 'Ce lien de réinitialisation n’est plus valide. Demandez-en un nouveau.',
    WRONG_PASSWORD: 'Le mot de passe actuel est incorrect.',
    SAME_PASSWORD: 'Le nouveau mot de passe doit être différent de l’ancien.',
    WEAK_PASSWORD: 'Ce mot de passe est trop faible. Choisissez-en un plus long ou plus varié.',
    REAUTH_REQUIRED: 'Pour des raisons de sécurité, déconnectez-vous puis reconnectez-vous avant de changer votre mot de passe.',
    NO_LOCAL_PASSWORD: 'Votre compte utilise une connexion externe : le mot de passe se gère depuis le lien « Mot de passe oublié ? ».',
    RATE_LIMITED: 'Trop de tentatives. Réessayez dans une minute.',
    LOCAL_AUTH_DISABLED: 'Cette action n’est pas disponible pour ce type de compte.',
  },
};
